import React, { useEffect } from 'react';
import CategoryTree from '../../../components/global/CategoryTree/CategoryTree';
import { setSubpage } from '../../../routes/routerSlice';
import { ConfigurationSubpage } from '../Configuration';
import { useTemplateOrCalculation } from '../../../hooks/useTemplateOrCalculation';
import SegmentPotentialDefinition from './SegmentPotentialDefinition/SegmentPotentialDefinition';

import { CalculationDetailSubpages } from '../../Calculations/calculationsLib';
import { MainContent, Row } from '@ydistri/ds';
import { useAppDispatch } from '../../../store';
import { CategoryTreePresentationMode } from '../../../components/global/CategoryTree/CategoryTreeTypes';

const ConfigurationCategories: React.FC = () => {
  const dispatch = useAppDispatch();
  const templateOrCalculation = useTemplateOrCalculation();

  useEffect(() => {
    dispatch(
      setSubpage(
        templateOrCalculation.type === 'Template'
          ? ConfigurationSubpage.CATEGORIES
          : CalculationDetailSubpages.CATEGORIES,
      ),
    );
  }, [dispatch, templateOrCalculation]);

  return (
    <>
      <CategoryTree
        presentationMode={
          templateOrCalculation.type === 'Template'
            ? CategoryTreePresentationMode.CONFIGURATION
            : CategoryTreePresentationMode.CALCULATION
        }
      />
      <MainContent>
        <Row $flexWrap="nowrap">
          <SegmentPotentialDefinition />
        </Row>
      </MainContent>
    </>
  );
};

export default ConfigurationCategories;
